// extracted by mini-css-extract-plugin
module.exports = {"close":"Gallery_close__zo-sD","spin":"Gallery_spin__1sJtV"};